import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  container: {
    flex: 1
  }
})
